export default {
    title: 'Congratulations! Your Self-Assessment has been launched!',
    goToDashboard: 'Go to dashboard',
};
